import React from 'react';
import styles from './PaymentMethod.module.css';
import Methods from '../../components/Methods';
import { Footer } from '../../components/Footer';

const PaymentMethod = () => {
  return (
    <div className={styles.container}>
      <Methods />
      <Footer />
    </div>
  );
};

export default PaymentMethod;
